/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

/**
 * @description User created
 */
export const createUser201Schema = z.object({
    "id": z.string(),
"email": z.string(),
"name": z.string(),
"active": z.boolean(),
"monitoringEnabled": z.boolean(),
"maxContactsAllowed": z.int().min(-9007199254740991).max(9007199254740991),
"createdAt": z.iso.datetime()
    })

/**
 * @description Invalid body
 */
export const createUser400Schema = z.any()

/**
 * @description A user with this id already exists
 */
export const createUser409Schema = z.any()

export const createUserMutationRequestSchema = z.object({
    "id": z.string().min(1),
"email": z.string().min(1),
"name": z.string().min(1),
"active": z.optional(z.boolean()),
"monitoringEnabled": z.optional(z.boolean()),
"maxContactsAllowed": z.optional(z.int().min(0).max(9007199254740991))
    })

export const createUserMutationResponseSchema = z.lazy(() => createUser201Schema)